import { Button } from "Components";
import { Body1, H3 } from "melodies-source/Text";
import React from "react";
import styled from "styled-components";

interface Props {
  onAdd: () => void;
}

export const UtmEmptyState: React.FC<Props> = ({ onAdd }) => {
  return (
    <Container>
      <H3>Add a UTM string and provide a label for reporting.</H3>
      <Body1>
        Each one here will appear in the “Entries by Source” and “Conversion
        Rate by Source” cards in your reporting dashboard.
      </Body1>
      <Button variant="outlined" onClick={onAdd}>
        + Add UTM String
      </Button>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  background-color: var(--content-background-color);
  padding: 40px;
  border-radius: 15px;
  text-align: center;

  button {
    width: fit-content;
    margin-top: 5px;
  }
`;
